<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Delivery Quality Inspection" active>

                                <b-row v-if="hasFailedDataDeliveryQualityInspection">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDeliveryQualityInspection.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryQualityInspectionsFailed" :fields="fieldsDeliveryQualityInspection" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryQualityInspection" :sort-desc.sync="sortDescDeliveryQualityInspection" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDeliveryQualityInspection.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryQualityInspections" :fields="fieldsDeliveryQualityInspection" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryQualityInspection" :sort-desc.sync="sortDescDeliveryQualityInspection" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Delivery Quality Inspection Detail" active>

                                <b-row v-if="hasFailedDataDeliveryQualityInspectionDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDeliveryQualityInspectionDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryQualityInspectionDetailsFailed" :fields="fieldsDeliveryQualityInspectionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryQualityInspectionDetail" :sort-desc.sync="sortDescDeliveryQualityInspectionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyDeliver)="row">
													{{ Number(row.item.qtyDeliver).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDeliveryQualityInspectionDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryQualityInspectionDetails" :fields="fieldsDeliveryQualityInspectionDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryQualityInspectionDetail" :sort-desc.sync="sortDescDeliveryQualityInspectionDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyDeliver)="row">
													{{ Number(row.item.qtyDeliver).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>
                            <b-tab title="Upload Delivery Quality Inspection Card" active>

                                <b-row v-if="hasFailedDataDeliveryQualityInspectionCard">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedDeliveryQualityInspectionCard.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryQualityInspectionCardsFailed" :fields="fieldsDeliveryQualityInspectionCard" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryQualityInspectionCard" :sort-desc.sync="sortDescDeliveryQualityInspectionCard" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qcDate)="row">
													{{ row.item.qcDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedDeliveryQualityInspectionCard.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="deliveryQualityInspectionCards" :fields="fieldsDeliveryQualityInspectionCard" :busy="isDataLoading"
                                                         :sort-by.sync="sortByDeliveryQualityInspectionCard" :sort-desc.sync="sortDescDeliveryQualityInspectionCard" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qcDate)="row">
													{{ row.item.qcDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import DeliveryQualityInspection from '@/models/DeliveryQualityInspection/DeliveryQualityInspection';
import DeliveryQualityInspectionList from '@/models/DeliveryQualityInspection/DeliveryQualityInspectionList';
import DeliveryQualityInspectionFilter from '@/filters/DeliveryQualityInspection/DeliveryQualityInspectionFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsDeliveryQualityInspection: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction", key: 'deliveryInstructionDiNumber', sortable: false},
				{"class" : "th-status", "label" : "Delivery Quality Inspection Status", key: 'deliveryQualityInspectionStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsDeliveryQualityInspectionDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty Deliver", key: 'qtyDeliver', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsDeliveryQualityInspectionCard: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Quality Inspection Detail", key: 'deliveryQualityInspectionDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Delivery Card", key: 'deliveryCardDeliveryCardNumber', sortable: false},
				{"class" : "th-status", "label" : "QC Status", key: 'qcStatusName', sortable: false},
				{"class" : "th-status", "label" : "Remarks", key: 'remarks', sortable: false},
				{"class" : "th-status", "label" : "QC Date", key: 'qcDate', sortable: false},
				{"class" : "th-status", "label" : "QC By", key: 'qcByFirstName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			deliveryQualityInspections : [],
			deliveryQualityInspectionsFailed: [],
			deliveryQualityInspectionId : '',
			sortByDeliveryQualityInspection: '',
			sortDescDeliveryQualityInspection: '',
			hasFailedDataDeliveryQualityInspection: false,
			totalFailedDeliveryQualityInspection: 0,
			totalSucceedDeliveryQualityInspection: 0,
			deliveryQualityInspectionDetails : [],
			deliveryQualityInspectionDetailsFailed: [],
			deliveryQualityInspectionDetailId : '',
			sortByDeliveryQualityInspectionDetail: '',
			sortDescDeliveryQualityInspectionDetail: '',
			hasFailedDataDeliveryQualityInspectionDetail: false,
			totalFailedDeliveryQualityInspectionDetail: 0,
			totalSucceedDeliveryQualityInspectionDetail: 0,

			deliveryQualityInspectionCards : [],
			deliveryQualityInspectionCardsFailed: [],
			deliveryQualityInspectionCardId : '',
			sortByDeliveryQualityInspectionCard: '',
			sortDescDeliveryQualityInspectionCard: '',
			hasFailedDataDeliveryQualityInspectionCard: false,
			totalFailedDeliveryQualityInspectionCard: 0,
			totalSucceedDeliveryQualityInspectionCard: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('deliveryqualityinspection/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('deliveryqualityinspection/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getDeliveryQualityInspectionForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getDeliveryQualityInspectionForUpload : async function() {
			let _this = this;
			this.$http.get('deliveryqualityinspection/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.deliveryQualityInspections = [];
_this.deliveryQualityInspectionDetails = [];
_this.deliveryQualityInspectionCards = [];


					if (response != null) {
						let result = response.data;
						_this.deliveryQualityInspections = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedDeliveryQualityInspection = _this.deliveryQualityInspections.length;

						_this.deliveryQualityInspectionsFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataDeliveryQualityInspection = true;
						_this.totalFailedDeliveryQualityInspection = 0;
						if(_this.deliveryQualityInspectionsFailed == undefined || _this.deliveryQualityInspectionsFailed.length === 0) _this.hasFailedDataDeliveryQualityInspection = false;
						if(_this.hasFailedDataDeliveryQualityInspection) _this.totalFailedDeliveryQualityInspection = _this.deliveryQualityInspectionsFailed.length;
						_this.deliveryQualityInspectionDetails = [];
						_this.deliveryQualityInspectionDetailsFailed = [];
						_this.hasFailedDataDeliveryQualityInspectionDetail = true;
						_this.totalSucceedDeliveryQualityInspectionDetail = 0;
						result.forEach(function(element) {
							_this.deliveryQualityInspectionDetails.push(...element.deliveryQualityInspectionDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedDeliveryQualityInspectionDetail = _this.deliveryQualityInspectionDetails.length;

							_this.deliveryQualityInspectionDetailsFailed.push(...element.deliveryQualityInspectionDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.deliveryQualityInspectionDetailsFailed == undefined || _this.deliveryQualityInspectionDetailsFailed.length === 0) _this.hasFailedDataDeliveryQualityInspectionDetail = false;
							if(_this.hasFailedDataDeliveryQualityInspectionDetail) _this.totalFailedDeliveryQualityInspectionDetail = _this.deliveryQualityInspectionDetailsFailed.length;
						});						_this.deliveryQualityInspectionCards = [];
						_this.deliveryQualityInspectionCardsFailed = [];
						_this.hasFailedDataDeliveryQualityInspectionCard = true;
						_this.totalSucceedDeliveryQualityInspectionCard = 0;
						result.forEach(function(element) {
							_this.deliveryQualityInspectionCards.push(...element.deliveryQualityInspectionCard.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedDeliveryQualityInspectionCard = _this.deliveryQualityInspectionCards.length;

							_this.deliveryQualityInspectionCardsFailed.push(...element.deliveryQualityInspectionCard.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.deliveryQualityInspectionCardsFailed == undefined || _this.deliveryQualityInspectionCardsFailed.length === 0) _this.hasFailedDataDeliveryQualityInspectionCard = false;
							if(_this.hasFailedDataDeliveryQualityInspectionCard) _this.totalFailedDeliveryQualityInspectionCard = _this.deliveryQualityInspectionCardsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'deliveryqualityinspection/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'DeliveryQualityInspection.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterDeliveryQualityInspection = new DeliveryQualityInspectionFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
